import React, { Component } from "react";

import * as Sentry from "@sentry/react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

/**
 * Route Error Boundary Component
 *
 * Strategic error boundary for route-specific error handling.
 * Reports all caught errors to Sentry for visibility.
 */
class RouteErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, {
      tags  : { component: "RouteErrorBoundary" },
      extra : { componentStack: errorInfo?.componentStack },
      level : "error",
    });
  }

  render() {
    const { hasError } = this.state;
    const { children, fallbackRoute = "/404" } = this.props;

    if (hasError) {
      // Graceful error recovery - redirect to fallback route
      return <Navigate to={fallbackRoute} replace />;
    }

    return children;
  }
}

RouteErrorBoundary.propTypes = {
  children      : PropTypes.node.isRequired,
  fallbackRoute : PropTypes.string,
};

export default RouteErrorBoundary;
